import React from 'react';
import {ImportProject} from "./components/ImportProject";
import {createRoot} from "react-dom/client";

function initImportProject() {
    const element = document.getElementById('ts-importProject-modal');
    if (element) {
        const root = createRoot(element!);
        root.render(<ImportProject />);
    }
}

export default initImportProject;
